'use client';
import _styled from '@emotion/styled/base';
import { ThemeProvider } from '@emotion/react';
import { getTheme } from './utils.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const ThemeColorSelector = _styled("style", {
  target: "e6671py0"
})("&~*{color:", ({
  theme
}) => theme.colorScheme.content.primary, ";}");
const emptyLocale = {};
function HubbleProvider({
  locale = emptyLocale,
  scheme = 'light',
  children,
  inverse
}) {
  return jsxs(ThemeProvider, {
    theme: parentTheme => getTheme(scheme, parentTheme, inverse, locale),
    children: [jsx(ThemeColorSelector, {}), children]
  });
}

export { HubbleProvider };
